import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    px: ['20px', '20px', '48px'],
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 351px)',
  }),
);

themeStyles.addBaseStyles('InputField')(({ theme }) =>
  css({
    placeholder: theme.colors.black,
  }),
);

themeStyles.addBaseStyles('DescriptionCopy')(
  css({
    fontSize: ['14px', '14px', '16px'],
    lineHeight: ['20px', '22px'],
    fontWeight: 300,
    my: '24px',
  }),
);

export default themeStyles;
